const PathConstants = {
  HOME: "/",
  ABOUT_US: "/about-us",
  CONTACT_US: "/contact-us",
  ACHIEVEMENTS_AND_STATISTICS: "/achievements-and-statistics",
  ACHIEVEMENTS: "/achievements",
  SUCCESS_STORY_DETAILS: "/success-story/:id",
  NAQSH_PLATFORM_DONATION: "/naqsh-platform-donation",
  PROJECTS: "/projects",
  PROJECT_DETAILS: "/project-details/:id",
  PARTNERS: "/partners",
  TEAM: "/team",
  PARTNERS_AND_TEAM: "/partners-and-team",
  ACTIVE_CAMPAIGNS: "/active-campaigns",
  CAMPAIGN_DETAILS: "/campaign-details/:id",
  DONATE: "/donate/:id",
  DONATE_PLATFORM: "/donate",
  SUCCESS_DONATION: "/success-payment",
  FAIL_DONATION: "/failed-payment",
  LOGIN: "/login",
  REGISTER: "/register",
  VERIFY_ACCOUNT: "/verify-account",
  FORGOT_PASSWORD: "/forgot-password",
  VERIFY_FORGOT_PASSWORD: "/verify-forgot-password",
  RESET_PASSWORD: "/reset-password",
  PROFILE: "/profile",
};

export default PathConstants;
